import { Paper, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { AttemptInfo } from "../../types/images";
import moment from "moment";

interface InfoCardProps {
  info: AttemptInfo;
}

export function InfoCard(props: InfoCardProps) {
  const { info } = props;

  const infoArray = Object.entries(info).map(([key, value]) => [key, value]);
  infoArray.pop();
  return (
    <>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableBody>
            {infoArray.map((attempt, a) => {
              return (
                <TableRow key={a}>
                  {attempt.map((item, i) => {
                    if (a === 1 && i === 1) {
                      return (
                        <TableCell
                          key={i}
                          sx={{
                            color: "black",
                            fontSize: "18px",
                            fontWeight: "bold",
                          }}
                          align="left"
                        >
                          {item ? "Authentication" : "Registration"}
                        </TableCell>
                      );
                    }
                    if ((a === 0 || a === 3) && i === 1) {
                      return (
                        <TableCell
                          key={i}
                          sx={{
                            color: "black",
                            fontSize: "18px",
                            fontWeight: "bold",
                          }}
                          align="left"
                        >
                          {moment(item).format("DD MMMM YYYY")}
                        </TableCell>
                      );
                    }
                    return (
                      <TableCell
                        key={i}
                        sx={{
                          color: `${i === 0 ? "grey" : "black"}`,
                          fontSize: `${i === 0 ? "16px" : "18px"}`,
                          fontWeight: `${i === 0 ? "none" : "bold"}`,
                        }}
                        align="left"
                      >
                        {item}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Typography
        sx={{
          marginTop: 10,
          color: "grey",
          fontSize: 18,
        }}
        textAlign={"left"}
      >
        Rejection Cause:
      </Typography>
      <Typography
        textAlign={"left"}
        sx={{
          fontWeight: "bold",
          color: "black",
          fontSize: 22,
        }}
      >
        {info.Rejection_Couse}{" "}
      </Typography>
    </>
  );
}
